import { getBalance } from '@wagmi/core';

import { Address } from 'viem';

import { wagmiConfig, WagmiConfigChain } from '@shared/common/providers/Web3Provider/wagmi';

import { truncateDecimals } from '../formatters';

const getUserTokenBalance = async ({
  address,
  chainId,
  token,
  truncate = 5,
}: {
  address: Address;
  chainId: WagmiConfigChain['id'];
  token?: Address;
  truncate?: number;
}) => {
  const userTokenInfo = await getBalance(wagmiConfig, {
    address,
    chainId,
    token,
  });
  const tokenBalance = Number(userTokenInfo.formatted);

  return {
    balance: truncate ? Number(truncateDecimals(tokenBalance, truncate)) : tokenBalance,
    symbol: userTokenInfo.symbol,
    raw: userTokenInfo,
  };
};

export type TokenBalance = Awaited<ReturnType<typeof getUserTokenBalance>>;

export const initZeroTokenBalance: () => TokenBalance = () => ({
  balance: 0,
  symbol: 'NONE',
  raw: {
    decimals: 0,
    formatted: '0',
    symbol: 'NONE',
    value: BigInt(0),
  },
});

export default getUserTokenBalance;
